import type { WeeklyScheduleSchema } from '@libs/data-access/entities'
import { mapKeys, mapValues } from 'lodash-es'
import moment from 'moment'

export const computeDisabledDays = (opts: {
  days: string[]
  lockedDays: { [day: string]: { isLocked: boolean } }
  weeklyschedule: WeeklyScheduleSchema
}) => {
  const isPublished = opts.weeklyschedule.published_at

  return mapValues(mapKeys(opts.days), day => {
    const { isLocked } = opts.lockedDays[day] || {}
    const isPublishedAndPast = isPublished
      ? moment(day).isSameOrBefore(moment(), 'day')
      : false

    return isLocked || isPublishedAndPast
  })
}
